const locationActionTypes = {
    START_GET_LOCATION: 'START_GET_LOCATION',
    GET_LOCATION_SUCCESS: 'GET_LOCATION_SUCCESS',
    GET_LOCATION_FAILURE: 'GET_LOCATION_FAILURE',

    START_ADD_LOCATION: 'START_ADD_LOCATION',
    ADD_LOCATION_SUCCESS: 'ADD_LOCATION_SUCCESS',
    ADD_LOCATION_FAILURE: 'ADD_LOCATION_FAILURE',

    START_DELETE_LOCATION: 'START_DELETE_LOCATION',
    DELETE_LOCATION_SUCCESS: 'DELETE_LOCATION_SUCCESS',
    DELETE_LOCATION_FAILURE: 'DELETE_LOCATION_FAILURE',
};

export default locationActionTypes;